export let BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

if (typeof window !== 'undefined') {
  const host = window.location.hostname;
  if (host !== 'localhost' && host !== '127.0.0.1') {
    BASE_URL = '';
  }
}

export async function apiRequest(endpoint: string, options: RequestInit = {}) {
  const url = `${BASE_URL}/api/master${endpoint}`;
  
  // Retrieve token from localStorage in client-side environment
  let token = '';
  if (typeof window !== 'undefined') {
    token = localStorage.getItem('token') || '';
  }

  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...options.headers,
    },
    ...options,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Network response was not ok');
  }

  return response.json();
}

// Multipart POST for endpoints that accept a JSON `payload` part plus an optional file - promoted
// out of expenseRecordService.ts's private submitMultipart now that paymentReceiptService.ts and
// salesService.ts's proforma payment endpoint are a second and third consumer.
export async function apiRequestMultipart(endpoint: string, payload: unknown, file?: File | null) {
  let token = '';
  if (typeof window !== 'undefined') {
    token = localStorage.getItem('token') || '';
  }
  const form = new FormData();
  form.append('payload', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
  if (file) form.append('file', file);

  const response = await fetch(`${BASE_URL}/api/master${endpoint}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: form,
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result.message || 'Network response was not ok');
  }
  return result;
}
